var map = {
	"./jpeg-optimizer_1.jpg": 7022,
	"./jpeg-optimizer_10.jpg": 976,
	"./jpeg-optimizer_11.jpg": 4834,
	"./jpeg-optimizer_12.jpg": 2910,
	"./jpeg-optimizer_13.jpg": 5343,
	"./jpeg-optimizer_14.jpg": 2423,
	"./jpeg-optimizer_15.jpg": 6537,
	"./jpeg-optimizer_16.jpg": 3871,
	"./jpeg-optimizer_17.jpg": 7252,
	"./jpeg-optimizer_18.jpg": 6468,
	"./jpeg-optimizer_19.jpg": 5340,
	"./jpeg-optimizer_2.jpg": 4576,
	"./jpeg-optimizer_20.jpg": 6551,
	"./jpeg-optimizer_3.jpg": 6463,
	"./jpeg-optimizer_4.jpg": 5971,
	"./jpeg-optimizer_5.jpg": 4557,
	"./jpeg-optimizer_6.jpg": 1466,
	"./jpeg-optimizer_7.jpg": 9049,
	"./jpeg-optimizer_8.jpg": 919,
	"./jpeg-optimizer_9.jpg": 5593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9074;